import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { ReactComponent as InfoCircle } from 'assets/images/info-circle-fine.svg';

export const StyledFloater = styled.span`
  display: inline-block;

  & span {
    display: inline-block;
  }
`;

export const TooltipBaloon = styled.div`
  max-width: 90vw;
  display: flex;
  align-items: center;
  padding: 20px;
  background-image: linear-gradient(73deg, ${ColorPalette.HEX.DimGray} 0%, ${ColorPalette.HEX.CharlestonGreen} 100%);
  color: ${ColorPalette.HEX.White};
  border-radius: 12px;
`;

export const InfoCircleIcon = styled(InfoCircle)`
  width: 24px;
  height: 24px;
  margin-right: 20px;
  flex-shrink: 0;
`;

export const Content = styled.div`
  padding-right: 40px;
  flex: 1;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.43;
  color: ${ColorPalette.HEX.White};
`;
